import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { UserContext } from '../../providers/UserContext';
import { BasketContext } from '../../providers/BasketContext';
import {
  ROLE_REFERENCING_STATUSES,
  OPPORTUNITY_REFERENCING_STATUSES,
  SF_ROLES,
  SF_TENANCY_TYPES,
} from '../../appConstants';
import {
  PATHS,
  LEAD_TENANT_JOURNEY,
  COMMON_JOURNEY,
  GUARANTOR_JOURNEY,
  COMMON_RENEWAL_JOURNEY,
  GUARANTOR_RENEWAL_JOURNEY,
} from '../../navigationConstants';

const StageRedirection = () => {
  const {
    opportunityStage,
    tenancyType,
    referencingStatus,
    referenceProvider,
    paymentPeriodicity,
    isReferencingExempt,
    isRenewal,
    role,
  } = useContext(UserContext);

  const { basketData: { periodicity } } = useContext(BasketContext);

  const referencingStatuses = [
    ROLE_REFERENCING_STATUSES.COMPLETED,
    ROLE_REFERENCING_STATUSES.IN_PROGRESS,
  ];
  let stages;
  switch (role) {
    case SF_ROLES.Guarantor:
      stages = isRenewal ? GUARANTOR_RENEWAL_JOURNEY : GUARANTOR_JOURNEY;
      break;
    case SF_ROLES.LeadTenant:
      stages = isRenewal ? COMMON_RENEWAL_JOURNEY : LEAD_TENANT_JOURNEY;
      break;
    default:
      stages = isRenewal ? COMMON_RENEWAL_JOURNEY : COMMON_JOURNEY;
      break;
  }

  console.log('[StageRedirection] routing inputs', {
    opportunityStage,
    tenancyType,
    referencingStatus,
    referenceProvider,
    paymentPeriodicity,
    isReferencingExempt,
    isRenewal,
    role,
    basketPeriodicity: periodicity,
    selectedJourneyStageMap: stages,
    resolvedStagePath: stages && stages[opportunityStage],
  });

  if (
    tenancyType === SF_TENANCY_TYPES.MID_TERM_CHANGE_OF_SHARER
    && !isReferencingExempt
    && (referenceProvider || '').toLowerCase() === 'homelet'
  ) {
    console.log('[StageRedirection] redirecting non-exempt mid-term change of sharer HomeLet user to referencing route', {
      route: PATHS.REFERENCING,
    });
    return <Redirect to={PATHS.REFERENCING} />;
  }

  if (OPPORTUNITY_REFERENCING_STATUSES.includes(opportunityStage)) {
    if (isReferencingExempt || referencingStatuses.includes(referencingStatus)) {
      console.log('[StageRedirection] redirecting to referencing progress route', {
        route: stages.ON_REFERENCING,
      });
      return <Redirect to={stages.ON_REFERENCING} />;
    }
    console.log('[StageRedirection] redirecting to referencing requested route', {
      route: stages.REFERENCES_REQUESTED,
    });
    return <Redirect to={stages.REFERENCES_REQUESTED} />;
  }

  if (opportunityStage === 'AUDIT') {
    console.log('[StageRedirection] redirecting audit stage to application complete', {
      route: PATHS.APPLICATION_COMPLETE,
    });
    return <Redirect to={PATHS.APPLICATION_COMPLETE} />;
  }

  // Little tampering for the navigation path regardless of role or tenancy type.
  if ((stages[opportunityStage] === PATHS.DIRECT_DEBIT) && paymentPeriodicity && paymentPeriodicity !== 'Monthly') {
    console.log('[StageRedirection] redirecting non-monthly direct debit journey to application complete', {
      route: PATHS.APPLICATION_COMPLETE,
    });
    return <Redirect to={PATHS.APPLICATION_COMPLETE} />;
  }

  if (!stages[opportunityStage]) {
    console.error('[StageRedirection] No route mapping found for stage', {
      opportunityStage,
      role,
      isRenewal,
      paymentPeriodicity,
      selectedJourneyStageMap: stages,
    });
  } else {
    console.log('[StageRedirection] redirecting to resolved route', {
      route: stages[opportunityStage],
    });
  }

  return <Redirect to={stages[opportunityStage]} />;
};

export default StageRedirection;
